import React, { Component } from 'react';
import { Button } from 'antd';

import styles from './styles.scss';

class ExamReview extends Component {
  renderQuestions() {
    const { quizState } = this.props;
    const { quizQueue } = quizState;

    const answeredQuestions = quizQueue.filter((quizObj) => quizObj.item.status).length;
    const totalQuestions = quizQueue.length;

    if (answeredQuestions === totalQuestions) {
      return <div>You&apos;ve answered all {totalQuestions} questions.</div>;
    }

    return (
      <div>
        You&apos;ve answered {answeredQuestions} of {totalQuestions} questions.
        <br />
        Use the menu to jump directly to any unanswered questions.
      </div>
    );
  }

  render() {
    const { handleFinishExam } = this.props;

    return (
      <div className={styles.layout}>
        <div className={styles.layoutInner}>
          That&apos;s the end!
          <br />
          <br />
          {this.renderQuestions()}
          <br />
          <br />
          When you&apos;re ready...
          <br />
          <Button data-aaa="scoreExamButton" type="primary" onClick={handleFinishExam}>
            Score the exam
          </Button>
        </div>
      </div>
    );
  }
}

export default ExamReview;
